import { ERROR, TIMELINE_DETAILS, MESSAGE, PROPERTY_DETAILS, PROPERTY_LIST, PROPERTY_REVIEWS } from './constants';
import { SERVER_ADDR } from '../../../constants';
import { resetMessage } from '../common/action';

export const addNewProperty = (formData) => async (dispatch, getState, api) => {
  try {

    if (formData.propertyImages && formData.propertyImages.length > 0) {
      const images = [];
      formData.propertyImages.forEach(f => {
        images.push(f.name);
      });

      formData.images = images;
      delete formData.propertyImages;
    }

    const res = await api
      .post(`${SERVER_ADDR}property`, { data: formData });
    
    if (res.code === 200) {
      dispatch({
        type: MESSAGE,
        message: 'Property Succesfully Added'
      });

      dispatch(resetMessage(MESSAGE));
      return;
    }

    throw new Error('Something went wrong');
  } catch (e) {
    console.log(e);
  }
}

export const getPropertyList = (page, offset) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}property?page=${page}&offset=${offset}`);

      if (res.body) {
        dispatch({
          type: PROPERTY_LIST,
          result: res.body
        });
      }
  } catch (e) {
    console.log(e);
  }
}

export const getPropertyDetail = (PropertyId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}property/${PropertyId}`);
        
    if (res.body) {
      if (res.body.propertyImages.length) {
        res.body.images = res.body.propertyImages;
      }

      delete res.body.propertyImages;

      dispatch({
        type: PROPERTY_DETAILS,
        result: res.body
      });

      return res.body;
    }
  } catch (e) {
    console.log(e);
  }
}

export const deletePropertyImage = (imageId) => async (dispatch, getState, api) => {
  try {
    const getDetails = getState().property.details;
    const newDetails = getDetails.images.filter(g => g.id !== imageId);
    const res = await api.del(`${SERVER_ADDR}property/image/${imageId}`);

    if (res.body) {
      const obj = Object.assign({}, getDetails, {
        images: newDetails
      });

      dispatch({
        type: PROPERTY_DETAILS,
        result: obj
      });
    }
  } catch (e) {
    console.log(e);
  }
}

export const editProperty = (formData, PropertyId) => async (dispatch, getState, api) => {
  try {
    if (formData.propertyImages && formData.propertyImages.length > 0) {
      const images = [];
      formData.propertyImages.forEach(f => {
        images.push(f.name);
      });

      formData.images = images;
      delete formData.propertyImages;
    }

    const res = await api
      .put(`${SERVER_ADDR}property/${PropertyId}`, { data: formData });

    dispatch(getPropertyDetail(PropertyId));

    dispatch({
      type: MESSAGE,
      message: 'Property Updated'
    });

    dispatch(resetMessage(MESSAGE));
  } catch (e) {
    console.log(e);
  }
}

export const deleteProperty = (propertyId) => async (dispatch, getState, api) => {
  try {
    const propertyList = getState().property.list.rows.filter(p => p.id !== propertyId);
    const count = getState().property.list.count > 0 ? getState().property.list.count - 1 : 0;
    const newList = {
      count,
      rows: propertyList
    };
    const res = await api
      .del(`${SERVER_ADDR}property/${propertyId}`);

    if (res.body) {
      dispatch({
        type: PROPERTY_LIST,
        result: newList
      });
    }

    dispatch(resetMessage(MESSAGE));
  } catch (e) {
    console.log(e);
  }
}

export const getReviews = (propertyId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}property/${propertyId}/reviews`);

    if (res.body) {
      dispatch({
        type: PROPERTY_REVIEWS,
        result: res.body
      });
    }
  } catch (e) {
    console.log(e);
  }
}

export const getTimeline = (userId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}timeline/${userId}`);
    
    if (res.code === 200) {
      dispatch({
        type: TIMELINE_DETAILS,
        result: res.body
      });

      return;
    }

    throw new Error('Something went wrong');
  } catch (e) {
    console.log(e);
  }
}